import { LlmDebugResult } from "results/llm/LlmDebugResult";
import { useApiService } from "services/ApiService";
import { LlmDebugCommand } from "commands/llm/LlmDebugCommand";
import { GetAnalyseClassResult } from "results/llm/GetAnalyseClassResult";
import { LlmAnalyseCommand } from "commands/llm/LlmAnalyseCommand";
import { GetClassAnalysisResult } from "results/llm/GetClassAnalysisResult";
import { GetPlayerInGameResult } from "results/llm/GetPlayerInGameResult";
import { GetClassResult } from "results/llm/GetClassResult";
import { GetHomeResult } from "results/llm/GetHomeResult";
import { GetGameResult } from "results/llm/GetGameResult";
import { GetStudentInClassResult } from "results/llm/GetStudentInClassResult";
import { GetStudentInClassAiAnalysisResult } from "results/llm/GetStudentInClassAiAnalysisResult";
import { GetGameAiAnalysisResult } from "results/llm/GetGameAiAnalysisResult";
import { GetClassAiAnalysisResult } from "results/llm/GetClassAiAnalysisResult";
import { LlmAnalyseResult } from "results/llm/LlmAnalyseResult";

export const LlmApiService = () => {
    const { get, post } = useApiService({ controller: "/llm" });

    return {
        debug: (command: LlmDebugCommand) => post<LlmDebugResult>("/debug", command),
        getHome: () => get<GetHomeResult>("/"),
        getClass: (classId: number) => get<GetClassResult>(`/class/${classId}`),
        getGame: (gameId: number) => get<GetGameResult>(`/game/${gameId}`),
        getAnalyseClass: () => get<GetAnalyseClassResult>("/analyse"),
        analyse: (command: LlmAnalyseCommand) => post<LlmAnalyseResult>("/analyse", command),
        getClassAnalysis: (classId: number) => get<GetClassAnalysisResult>(`/class-analysis/${classId}`),
        getStudentInClass: (id: number) => get<GetStudentInClassResult>(`/student-in-class/${id}`),
        getPlayerInGame: (gameId: number, playerId: number) =>
            get<GetPlayerInGameResult>(`/game/${gameId}/player/${playerId}`),
        getStudentInClassAiAnalysis: (id: number) =>
            get<GetStudentInClassAiAnalysisResult>(`/student-in-class/${id}/ai-analysis`),
        getGameAiAnalysis: (gameId: number) => get<GetGameAiAnalysisResult>(`/game/${gameId}/ai-analysis`),
        getClassAiAnalysis: (classId: number) => get<GetClassAiAnalysisResult>(`/class/${classId}/ai-analysis`),
    };
};
